import { render, staticRenderFns } from "./m_company005.vue?vue&type=template&id=1a31a082&"
import script from "./m_company005.vue?vue&type=script&lang=js&"
export * from "./m_company005.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports